<template>
  <v-card class="pa-0">
    <div class="pa-3">
      <p class="body-2 font-weight-medium" v-if="fullText">
        {{ fullText }}
      </p>
      <p class="body-2 font-weight-medium" v-else>
        Are you sure you want to {{ action }} this {{ item }}?
      </p>
      <p v-if="description" class="body-2">{{ description }}</p>
    </div>
    <v-divider></v-divider>
    <v-card-actions>
      <v-btn text lass="text-xs-left" color="error" @click="remove()"
        >YES</v-btn
      >
      <v-spacer></v-spacer>
      <v-btn text align-end class="text-xs-right" color="info" @click="close()"
        >NO</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    item: String,
    action: {
      type: String,
      default: "delete",
    },
    fullText: String,
    description: String,
  },
  methods: {
    close() {
      this.$emit("close");
    },
    remove() {
      this.$emit("remove");
    },
  },
};
</script>
